import { type ReactNode, useRef, useState } from "react";

import { DataTableSettingsContext } from "./data-table-settings-context";

export function DataTableSettingsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [showAddPreference, setShowAddPreference] = useState(false);
  const [showManagePreferences, setShowManagePreferences] = useState(false);

  const triggerRef = useRef<HTMLButtonElement>(null);

  const focusTrigger = () => {
    triggerRef.current?.focus();
  };

  return (
    <DataTableSettingsContext.Provider
      value={{
        showAddPreference,
        setShowAddPreference,
        showManagePreferences,
        setShowManagePreferences,
        triggerRef,
        focusTrigger,
      }}
    >
      {children}
    </DataTableSettingsContext.Provider>
  );
}
